import Text from "components/Text";
import Paper from "components/Paper";

import styles from "./index.module.css";
const OperatingSchedule = () => {
    return (
        <div className={styles.confirmationPage}>
            <Paper className={styles.paper}>
                <Text type={"h2"} className={styles.alignTextCenter}>
                    Program de funcționare
                </Text>
                <div className={styles.programCard}>
                    <Text type={"h3"} className={styles.alignTextCenter}>
                        Luni - Vineri
                    </Text>
                    <Text type={"l"} className={styles.alignTextCenter}>
                        08:30 - 20:00
                    </Text>
                </div>
                <Text type={"h3"} className={styles.alignTextCenter}>
                    * cu excepția sărbătorilor legale
                </Text>

            </Paper>
        </div>
    );
};

export default OperatingSchedule;